import { css } from '@/styled-system/css';

export const dropdownSelectChipStyles = css.raw({
  textStyle: 'body',
  color: 'Combobox.Input.text.populated',
});
